<div class="header-container">
  <app-header></app-header>
</div>

<div class="min-h-screen flex flex-col">
  <div
    class="flex-grow flex items-center justify-center bg-[#ECF7FF] px-4 py-20"
  >
    <div class="bg-white p-8 md:p-10 shadow-lg w-full max-w-5xl">
      <h2 class="text-2xl font-bold text-gray-800 mb-2">
        {{ "OTP.TITLE" | translate }}
      </h2>
      <hr class="mb-4 border-gray-300" />

      <p class="text-gray-600 font-medium mb-6">
        {{ "OTP.DESCRIPTION" | translate }}
        <span class="text-primary-color font-semibold">{{
          phoneNumber || email
        }}</span>
      </p>

      <div class="mb-6">
        <label for="otp" class="block text-sm font-medium text-gray-700 mb-2">
          {{ "OTP.LABEL" | translate }}
        </label>

        <div class="mb-6">
          <div class="flex flex-col md:flex-row md:items-center">
            <input
              type="text"
              id="otp"
              [(ngModel)]="otp"
              class="flex-1 mr-10 border border-gray-300 rounded-md px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary-color"
              placeholder="12345678"
            />

            <button
              type="button"
              (click)="confirmOtp()"
              class="bg-primary-color hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md transition mr-2"
            >
              Confirm
            </button>

            <button
              type="button"
              class="text-primary-color border border-primary-color hover:bg-primary-color hover:text-white py-2 px-6 rounded-md transition"
            >
              Change Number
            </button>
          </div>
        </div>

        <div class="text-md font-medium text-gray-600 mb-4 text-left">
          Didn't receive the OTP?
        </div>

        <div class="text-left mb-32">
          <button
            type="button"
            (click)="resendOtp()"
            class="bg-primary-color hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md transition"
          >
            Resend
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Footer -->
  <app-footer layout="slim"></app-footer>
</div>
